export default function upperCase(string: string): string {
    return string.toUpperCase();
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/app/modules/shared/filters/upperCase.ts